import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { AppFilter, ConfirmModal } from 'src/modules/shared';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import {
	LookupDataModal
	// TemplateNewModal
} from '../../../modals';
import { OptionService, OptionTypeService } from '../../../services';
import { ActivatedRoute } from '@angular/router';
@Component({
	selector: 'app-lookup-data-list',
	templateUrl: './lookup-data-list.component.html',
	styleUrls: [ './lookup-data-list.component.scss' ]
})
export class LookupDataListComponent implements OnInit {
	filter: AppFilter = new AppFilter();
	pending: boolean;
	totalItems: number = 5;
	rows: number = 2;
	currentPage: number = 1;
	maxSize: number = 7;
	lookupTemplates: Array<any>;
	optionType;
	error: any;
	success: any;
	// search filter (contains optionType and seach index on optionName)
	searchFilter = {
		groupOp: 'AND',
		rules: [
			{
				field: 'optionType.optionTypeId',
				op: 'eq',
				data: ''
			},
			{
				field: 'optionName',
				op: 'cn',
				data: ''
			}
		]
	};
	optionTypeId;
	constructor(
		private route: ActivatedRoute,
		private location: Location,
		private modalService: SuiModalService,
		private optionSvc: OptionService,
		private optionTypeSvc: OptionTypeService
	) {
		this.optionTypeId = this.route.snapshot.paramMap.get('id');
		this.searchFilter.rules[0].data = this.optionTypeId;
		this.filter.filters = JSON.stringify(this.searchFilter);
		this.getPage(1);
		this.getOptionType();
	}

	getOptionType() {
		let searchFilter = {
			groupOp: 'AND',
			rules: [
				{
					field: 'optionTypeId',
					op: 'eq',
					data: ''
				}
			]
		};
		let filter = new AppFilter({ sidx: 'optionTypeId', rows: 10 });
		searchFilter.rules[0].data = this.optionTypeId;
		filter.filters = JSON.stringify(searchFilter);
		this.optionTypeSvc.getOptionTypes({ params: filter }).subscribe(
			(res: any) => {
				this.optionType = res.rows[0];
			},
			(error) => {
				this.pending = false;
				this.error = error.error.errorMessage ? error.error.errorMessage
                                              : error.error ? error.error
                                              : error;
			}
		);
	}

	// get page request options with filter params
	getPage(page) {
		this.filter.page = page;
		this.pending = true;
		this.optionSvc.getOption({ params: this.filter }).subscribe(
			(res: any) => {
				this.pending = false;
				this.totalItems = +res.records;
				this.rows = this.filter.rows;
				this.lookupTemplates = res.rows;
			},
			(error) => {
				this.pending = false;
				this.error = error.error.errorMessage ? error.error.errorMessage
                                              : error.error ? error.error
                                              : error;
			}
		);
	}
	goBack() {
		this.location.back();
	}

	newLookup() {
		this.modalService
			.open(new LookupDataModal('Add Lookup', { optionType: this.optionType }, false, ModalSize.Tiny))
			.onApprove((eq) => {
				// this.selectedCertificateHolder = eq;
				// this.startApplication(eq);
				this.getPage(1);
			})
			.onDeny(() => console.log('add certificate holder cancel'));
	}
	onEdit(event) {
		this.modalService
			.open(
				new LookupDataModal('Edit Lookup', { option: event, optionType: this.optionType }, true, ModalSize.Tiny)
			)
			.onApprove((eq) => {
				// this.selectedCertificateHolder = eq;
				// this.startApplication(eq);
				this.getPage(1);
			})
			.onDeny(() => console.log('add certificate holder cancel'));
	}
	deleteTemplate() {
		this.modalService
			.open(
				new ConfirmModal(
					'Delete lookup data?',
					'Are you sure you want to delete this lookup data?',
					ModalSize.Tiny
				)
			)
			.onApprove(() => {})
			.onDeny(() => {});
	}
	searchRecords(event) {
		this.searchFilter.rules[1].data = event;
		this.filter.filters = JSON.stringify(this.searchFilter);
		this.getPage(1);
	}
	displayRecords(row) {
		this.filter['rows'] = row;
		this.getPage(1);
	}
	sortRecords(event) {
		this.filter.sord = event;
		this.getPage(1);
	}
	nextPage(page) {
		this.currentPage = page;
		this.getPage(this.currentPage);
	}
	onDelete(event) {
		this.modalService
			.open(
				new ConfirmModal(
					'Delete lookup data?',
					'Are you sure you want to delete this lookup data?',
					ModalSize.Tiny
				)
			)
			.onApprove(() => {
				this.pending = true;
				this.optionSvc.deleteOption({ optionTypeId: event.optionId }).subscribe(
					(res) => {
						this.pending = false;
						this.success = 'Lookup deleted sucessfully';
						this.getPage(1);
					},
					(error) => {
						this.pending = false;
						this.error = error.error.errorMessage ? error.error.errorMessage
                                                  : error.error ? error.error
                                                  : error;
					}
				);
			})
			.onDeny(() => {});
	}
	ngOnInit(): void {}
}
